import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon   from '@mui/icons-material/KeyboardArrowUp';
import ListaParcelas         from "./ListaParcelas";
import ContextoSimulacao     from "../../common/context/ContextoSimulacao.js";
import Descricao from "./Descricao";

export default function Parcelas()
{
    const [expanded, setExpanded] = useState(false);
    const {simulacao} = useContext(ContextoSimulacao);
    const handleExpandClick = ()=>{ setExpanded(!expanded) };

    useEffect(()=>{        
        Object.keys(simulacao).length > 0 && setExpanded(true); 
    }, [simulacao])

    return(
        <div>
            <Card className=" p-2 m-5">
                <Card.Body>
                    <Row>
                        <Col md="10">
                            <h4 className="text-uppercase">
                                Simulação de parcelas
                            </h4>
                        </Col>
                        <Col md="2" className="text-end">
                            <Button 
                                variant="outline-primary" 
                                size="sm"
                                onClick={ handleExpandClick }
                                data-bs-toggle="collapse" 
                                data-bs-target="#lista-parcelas" 
                                aria-expanded="false"
                            >
                                { 
                                    expanded == true ? 
                                    <KeyboardArrowUpIcon />:<KeyboardArrowDownIcon /> 
                                }
                            </Button>
                        </Col>
                    </Row>
                    <Row 
                        className={expanded === true ? "pt-5 collapse show" : "pt-5 collapse" } 
                        id="lista-parcelas"
                    >
                        {
                            Object.keys(simulacao).length > 0 && 
                                <Descricao descricao={ simulacao.descricaoProduto }/>
                        }
                        <ListaParcelas />
                    </Row>
                </Card.Body>
            </Card>
        </div>
    );
}